import React, { useEffect, useState } from 'react';
import {
    BreadCrumbs,
    PageTitleWithToolTip,
    DataGrid,
    CommonModal as DetailsModal,
} from '../../Common';
import Routes from '../../../routes';
import { Grid, Tooltip, Box, Stack, Typography } from '@mui/material';
import {
    dataGridContainerProps,
    select_commonCellProps,
    text_commonCellProps
} from "../../Common/DataGrid/utils";
import { getDateRangeFilterOperator } from "../../Common/DataGrid/FilterComponents";
import { fetchFilterValues } from "../../../utils";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { Grey2 } from "../../../color_utils";
import VisibilityIcon from '@mui/icons-material/Visibility';
import Divider from '@mui/material/Divider';

const dateRangeFilterOperator = getDateRangeFilterOperator({});

const WebHookLogs = () => {
    const [filters, setFilters] = useState([]);
    const [modalState, setModalState] = useState({
        open: false,
        row: null,
    });

    const columns = [
        {
            field: 'createDate',
            headerName: 'Created On',
            valueGetter: (date) => date,
            filterOperators: dateRangeFilterOperator,
            flex: 1,
        },
        {
            field: 'endpoint',
            headerName: 'API Endpoint',
            filterable: false,
            sortable: false,
            width: 200
        },
        {
            field: 'event',
            headerName: 'Event Type',
            ...select_commonCellProps,
        },
        {
            field: 'entity',
            headerName: 'Object Type',
            ...select_commonCellProps,
        },
        {
            field: 'entityId',
            headerName: 'Object ID',
            ...text_commonCellProps,
        },
        {
            field: 'field',
            headerName: 'Field',
            ...select_commonCellProps,
        },
        {
            field: 'statusCode',
            headerName: 'Status Code',
            ...select_commonCellProps,
            renderCell: ({ row: { statusCode }}) => <span>{statusCode}</span>
        },
        {
            field: 'body',
            headerName: 'Request Body',
            filterable: false,
            width: 200,
        },
        {
            field: 'responseBody',
            headerName: 'Response Body',
            filterable: false,
            width: 200,
        },
        {
            type: 'actions',
            field: 'Quick Actions',
            width: 25,
            getActions: ({ row }) => ([
                <GridActionsCellItem
                    sx={{display: { xs: 'none', md: 'inline-flex' }}}
                    icon={
                        <Tooltip
                            title="Open Modal"
                        >
                            <VisibilityIcon sx={{ color: Grey2 }} />
                        </Tooltip>
                    }
                    onClick={() => setModalState(p => ({
                        ...p,
                        open: true,
                        row: [{
                            ...row,
                            body: JSON.parse(row.body),
                            responseBody: row.responseBody ? JSON.parse(row.responseBody) : null,
                        }]
                    }))}
                />
            ])
        }
    ];

    const fetchData = async () => {
        const data = await fetchFilterValues(Routes.Account.WebHookLogFilters());
        setFilters(data);
    };
    
    const renderJson = ({ data }) => (
        JSON.stringify(data, null, 2)
    );

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: 'Account Details', to: `/Account` },
                    { text: 'WebHook Logs' }
                ]}
            />

            <Grid container>
                <Grid item xs={6}>
                    <PageTitleWithToolTip
                        pageTitle="WebHook Logs"
                    />
                </Grid>
                <Grid item {...dataGridContainerProps}>
                    <DataGrid
                        hideExportButton
                        defaultSort={"createDate_desc"}
                        url={Routes.Account.WebHookLogs()}
                        filterOptions={filters}
                        noResultText="Oops...It is empty here..."
                        noResultText2="No WebHook Logs to display"
                        tableId={"webhook-log-table"}
                        columns={columns}
                        rowCount={100}
                    />
                </Grid>
            </Grid>

            <DetailsModal
                open={modalState.open}
                close={() => setModalState(p => ({...p, open: false }))}
                maxWidth={"fit-content"}
            >
                <Stack
                    direction="column"
                    spacing={2}
                    divider={<Divider />}
                >
                    {modalState.row?.length ? (
                        columns.filter(x => x.type !== "actions").map((x, key) => {
                            console.log('modalState?.row', modalState?.row);
                            return (
                                <Box
                                    key={key}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        py: 0.5,
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{ fontWeight: 500 }}
                                    >
                                        {x.headerName}
                                    </Typography>

                                    {["body", "responseBody"].includes(x.field) ? (
                                        <Box
                                            component="pre"
                                            sx={{
                                                m: 4,
                                                whiteSpace: "pre-wrap",
                                                wordBreak: "break-word",
                                                fontFamily: "monospace",
                                                fontSize: 14,
                                                lineHeight: 1.4,
                                            }}
                                        >
                                            {renderJson({ data: modalState?.row[0][x.field] ?? {} })}
                                        </Box>
                                    ) : (
                                        <Typography
                                            variant="body2"
                                            sx={{ ml: 2, textAlign: "right", wordBreak: "break-word" }}
                                        >
                                            {`${modalState?.row[0][x.field]}`}
                                        </Typography>
                                    )}
                                </Box>
                            );
                        })
                    ) : null}
                </Stack>
            </DetailsModal>
        </>
    );
};

export default WebHookLogs;
